import { StaticFormFieldMappings } from '@features/service/pages/service-request-form-page/service-request-form-response.mapper.util';
import { CI_STATIC_FIELD_MAPPINGS } from '@features/service/pages/service-request-form-page/components/forms/ci/ci-form.mappings';
import { HI_STATIC_FIELD_MAPPINGS } from '@features/service/pages/service-request-form-page/components/forms/hi/hi-form.mappings';
import { VENTI_STATIC_FIELD_MAPPINGS } from '@features/service/pages/service-request-form-page/components/forms/venti/venti-form.mappings';

/** Backend question-id mappings for static service request forms. */
const SHARED_GENERAL_INFO_MAPPINGS: StaticFormFieldMappings = {
  serviceRequestNo: 7101,
  serviceRequestType: 7102,
  dateCreated: 7103,
  createdBy: 7104,
  customerAccount: 7105,
  shipToLocation: 7106,
  shipToCoordinates: 7107,
  shipToLastInspection: 7108,
  lsd: 7109,
};

const SHARED_TECH_SIGNATURE_MAPPINGS: StaticFormFieldMappings = {
  technicianName: 98002,
  serviceDate: 98003,
  technicianNotes: 98004,
  serviceTime: 98005,
  inspectorMobile: 98006,
  technicianSignature: 98007,
  inspectorEmail: 98008,
  inspectorDesignation: 98009,
  inspectorRotNumber: 98010,
  rotExpiryDate: 98011,
  locationLongitude: 98012,
  locationLatitude: 98013,
};

const STATIC_FORM_FIELD_MAPPINGS: Record<string, StaticFormFieldMappings> = {
  PP07: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    inspectionNo: 7101,
    inspectionType: 7102,
    inspectionOutcome: 7103,
    outcomeRemarks: 7104,
    equipmentOther: 7121,
    equipment: 7110,
    serialNo: 7111,
    equipmentServiceType: 7112,
    assetType: 7113,
    assetSubType: 7114,
    owner: 7115,
    manufacturer: 7116,
    manufactureDate: 7117,
    tankSize: 7118,
    maxWorkingPressure: 7119,
    crn: 7120,
    tankChecklistPaint: 7201,
    tankChecklistCorrosion: 7202,
    tankChecklistLid: 7203,
    tankChecklistLeaks: 7204,
    tankChecklistDefectsFree: 7205,
    tankChecklistFireDamage: 7206,
    tankChecklistUnauthorizedWelding: 7207,
    tankChecklistLegs: 7208,
    tankChecklistBases: 7209,
    tankChecklistFillValve: 7210,
    tankChecklistPressureGauge: 7211,
    tankChecklistNotes: 7212,
    prvManufacturer: 7301,
    prvModel: 7302,
    prvCertificationUl: 7303,
    prvSpringType: 7304,
    prvScfmRating: 7305,
    prvDate: 7306,
    prvPressureSetting: 7307,
    prvInspectorComments: 7308,
    prvChecklistCap: 7311,
    prvChecklistWeepHole: 7312,
    prvChecklistSeat: 7313,
    prvChecklistBody: 7314,
    prvChecklistDebris: 7315,
    prvChecklistDischarge: 7316,
    prvChecklistExternalSpring: 7317,
    prvChecklistSafeDischarge: 7318,
    finalEvaluationAcceptable: 7401,
    finalEvaluationFollowup: 7402,
    finalEvaluationRatingPlateIncluded: 7403,
    ratingPlateImage: 7404,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  PP01: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    inspectionNo: 7210,
    inspectionType: 7211,
    inspectionDate: 7212,
    inspectionOutcome: 7213,
    outcomeRemarks: 7214,
    equipmentOther: 7215,
    equipment: 7220,
    serialNo: 7221,
    equipmentServiceType: 7222,
    assetType: 7223,
    assetSubType: 7224,
    owner: 7225,
    equipmentStatus: 7226,
    gpsCoordinates: 7227,
    manufacturer: 7228,
    manufactureDate: 7229,
    tankSize: 7230,
    maxWorkingPressure: 7231,
    crn: 7232,
    stampRecertificationDate: 7233,
    ratingsPlatePictures: 7234,
    tankRatingPlatePhoto: 7235,
    equipmentComments: 7236,
    propaneStorageRatingPlateImage: 7237,
    propaneStorageClearance: 7240,
    propaneStoragePhysicalProtection: 7241,
    propaneStorageSupportBase: 7242,
    propaneStorageLevelPlumb: 7243,
    propaneStorageEasyFilling: 7244,
    propaneStorageCompanyId: 7245,
    propaneStoragePaint: 7246,
    propaneStorageValvesCondition: 7247,
    propaneStorageDomeCover: 7248,
    propaneStoragePhysicalCondition: 7249,
    propaneStorageReliefValveCaps: 7250,
    propaneStorageShutoffValves: 7251,
    propaneStorageWeedsClear: 7252,
    regulatorType: 7280,
    regulatorManufacturer: 7281,
    regulatorModel: 7282,
    regulatorManufactureDate: 7283,
    regulatorLockupPressure: 7284,
    regulatorSupplyPressure: 7285,
    regulatorRatingPlatePhoto: 7286,
    regulatorNotes: 7287,
    propaneSystemTwoStage: 7270,
    propaneSystemRegulatorProtected: 7271,
    propaneSystemPipingObstruction: 7272,
    propaneSystemPipingSupported: 7273,
    propaneSystemGasLinesIdentified: 7274,
    propaneSystemShutoffValves: 7275,
    propaneSystemRegulatorVenting: 7276,
    propaneSystemLeakFree: 7277,
    propaneSystemAppliancesReady: 7278,
    propaneSystemPhoto: 7279,
    applianceEquipment: 7290,
    applianceEquipmentOther: 7300,
    applianceSerialNo: 7291,
    applianceAssetType: 7292,
    applianceAssetSubType: 7293,
    applianceOwner: 7294,
    applianceManufacturer: 7295,
    applianceManufactureDate: 7296,
    applianceTankSize: 7297,
    applianceMaxWorkingPressure: 7298,
    applianceCrn: 7299,
    applianceNotes: 7301,
    applianceModel: 7324,
    applianceManifoldPressureHigh: 7328,
    applianceManifoldPressureLow: 7325,
    applianceLockupPressure: 7326,
    applianceSupplyPressure: 7327,
    applianceCompanyOwned: 7310,
    applianceFieldConversion: 7311,
    applianceApprovedForUse: 7312,
    appliancePolarityVoltage: 7313,
    applianceInstalledPerCode: 7314,
    applianceVentingAcceptable: 7315,
    applianceVentCorrosionDamage: 7316,
    applianceCombustionAir: 7317,
    applianceHeatExchangerLeakage: 7318,
    applianceCombustionChamber: 7319,
    applianceControlsChecked: 7320,
    applianceBurnersAdjusted: 7321,
    applianceFreeFromDefects: 7322,
    applianceApprovedSpecify: 7323,
    applianceCarbonMonoxideReading: 7371,
    applianceInspectionComments: 7372,
    applianceContractorInformation: 7373,
    applianceAssetRatingsPlatePhoto: 7374,
    applianceAssetRatingsPlatePhoto2: 7375,
    evaluationInspector: 7330,
    installationAcceptable: 7331,
    evaluationFollowUpNeeded: 7332,
    deficiency: 7360,
    followupInspectionDate: 7361,
    complianceTimeframe: 7362,
    makingCorrections: 7363,
    followupCorrectiveAction: 7364,
    deficiencyCorrectedBy: 7365,
    deficiencyCorrectedDate: 7366,
    pictureOfRedTag: 7367,
    correctionPhoto: 7368,
    correctionComments: 7369,
    followupTechnicianCertificateNumber: 7370,
    customerPresentDuringInspection: 7340,
    customerAdvisedOperation: 7341,
    customerAdvisedEmergencyShutoff: 7342,
    customerAcknowledgementName: 7343,
    customerSignature: 7344,
    signOffComments: 7350,
    actionTaken: 7351,
    technicianComments: 7352,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  PP03: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    equipment: 8110,
    serialNo: 8111,
    equipmentServiceType: 8112,
    assetType: 8113,
    assetSubType: 8114,
    owner: 8115,
    equipmentStatus: 8116,
    gpsCoordinates: 8117,
    manufacturer: 8118,
    manufactureDate: 8119,
    tankSize: 8120,
    maxWorkingPressure: 8121,
    crn: 8122,
    stampRecertificationDate: 8123,
    cylinderPhotosIncluded: 8130,
    cylinderPhotos: 8131,
    tankRatingPlatePhoto1: 8132,
    tankRatingPlatePhoto2: 8133,
    equipmentComments: 8134,
    signOffComments: 8140,
    actionTaken: 8141,
    technicianComments: 8142,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  'PP-DISP': {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    inspectionNo: 9210,
    inspectionType: 9211,
    inspectionDate: 9212,
    inspectionOutcome: 9213,
    outcomeRemarks: 9214,
    equipmentOther: 9215,
    equipment: 9220,
    serialNo: 9221,
    equipmentServiceType: 9222,
    assetType: 9223,
    assetSubType: 9224,
    owner: 9225,
    manufacturer: 9226,
    manufactureDate: 9227,
    tankSize: 9228,
    crn: 9229,
    prvDate: 9230,
    modeOfOperation: 9231,
    facilityTssaLicenseNo: 9232,
    licenseExpiryDate: 9233,
    tssaLicenseImage: 9234,
    tankRatingPlate: 9235,
    pipingMeetsCode: 9240,
    vibrationExpansionProvisions: 9241,
    pipingAboveGradeSupported: 9242,
    aboveGroundPipingPainted: 9243,
    undergroundPipingCorrosionProtected: 9244,
    hydrostaticReliefValves: 9245,
    excessFlowValves: 9246,
    hosesFreeOfLeaks: 9247,
    nozzleGoodCondition: 9248,
    propanePipingFreeOfLeaks: 9249,
    tankProtectedFromDamagePiping: 9250,
    propaneTankChecklistNotes: 9251,
    propaneTankChecklistPhotos: 9252,
    tankPaintedCondition: 9260,
    gradeBaseRequired: 9261,
    clearanceCombustibles: 9262,
    clearanceAdjacentWalls: 9263,
    clearanceDrains: 9264,
    clearancePropertyLines: 9265,
    clearanceDoorsWindows: 9266,
    clearanceOtherFuelTanks: 9267,
    clearanceUndergroundTanks: 9268,
    tankReliefValvesRainCaps: 9269,
    tankProtectedFromDamageTank: 9270,
    pipingChecklistNotes: 9271,
    pipingChecklistPhotos: 9272,
    operatingPersonnelTrained: 9280,
    remoteShutoffCondition: 9281,
    breakawayFittingOperational: 9282,
    iscValveCondition: 9283,
    fusibleLinkInPlace: 9284,
    electricalWiringConform: 9285,
    fireExtinguisherAvailable: 9286,
    annualFireExtinguisherInspectionDate: 9287,
    safetyMidPhotos: 9288,
    nonSmokingSignPosted: 9289,
    noIgnitionSourceSignPosted: 9290,
    transportCylinderSecured: 9291,
    scalesMeasurementCanadaCertification: 9292,
    autoDispensersMeasurementCanadaCertification: 9293,
    safetyChecklistNotes: 9294,
    safetyChecklistPhotos: 9295,
    evaluationInspector: 9300,
    inspectorCertificateNumber: 9301,
    installationAcceptable: 9302,
    evaluationFollowUpNeeded: 9303,
    deficiency: 9310,
    followupInspectionDate: 9311,
    complianceTimeframe: 9312,
    makingCorrections: 9313,
    followupCorrectiveAction: 9314,
    deficiencyCorrectedBy: 9315,
    deficiencyCorrectedDate: 9316,
    pictureOfRedTag: 9317,
    correctionPhoto: 9318,
    correctionComments: 9319,
    followupTechnicianCertificateNumber: 9322,
    signOffComments: 9320,
    actionTaken: 9321,
    technicianComments: 9323,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  PP06: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    inspectionNo: 9500,
    inspectionType: 9501,
    inspectionDate: 9502,
    inspectionOutcome: 9503,
    outcomeRemarks: 9504,
    equipmentOther: 9505,
    equipment: 9510,
    serialNo: 9511,
    equipmentServiceType: 9512,
    assetType: 9513,
    assetSubType: 9514,
    owner: 9515,
    equipmentStatus: 9523,
    manufacturer: 9516,
    manufactureDate: 9517,
    tankSize: 9518,
    crn: 9519,
    prvDate: 9520,
    equipmentRatingPlate: 9521,
    equipmentComments: 9522,
    vaporizerInspectorComments: 9524,
    vaporizerOptionalPhoto: 9525,
    thermostatOperatingCorrectly: 9530,
    thermostatOffExtinguishesBurnerPilot: 9531,
    thermostatControlUndamaged: 9532,
    thermostatThermoWellUpdated: 9533,
    igniterBatteryVoltageChecked: 9534,
    inletStrainerCleaned: 9535,
    pilotBurnerInspected: 9536,
    pilotLightUniformStrong: 9537,
    multiChamberPilotSpreaderBar: 9538,
    thermocoupleConditionChecked: 9539,
    mainBurnersCleanedTestFired: 9540,
    mainBurnerFlameNormal: 9541,
    burnerRegulatorTested: 9542,
    electronicReignitionValveDropout: 9543,
    dripLegDrained: 9544,
    reliefValvesFreeOfCorrosion: 9545,
    reliefValvesWeatherproofCaps: 9546,
    heatExchangerFlameImpingement: 9547,
    ultrasonicThicknessTest: 9548,
    heatExchangerDebrisRemoved: 9549,
    vaporizerPipingDamage: 9550,
    pipingPaintAcceptable: 9551,
    liquidInletValveKitReplaced: 9552,
    capacityControlValveKitReplaced: 9553,
    vaporizerBaseMountSecure: 9554,
    vaporizerCabinetCleared: 9555,
    cabinetProtectionFrameGood: 9556,
    leakCheckPipingPrvs: 9557,
    mainSystemRegulatorServiced: 9558,
    equipmentInspectionTagAttached: 9559,
    electricSolenoidValveLeakTest: 96500,
    electricLiquiSafePerformanceTest: 96501,
    electricLiquiSafeLatchTest: 96502,
    electricReliefValvesInspect: 96503,
    electricContactorInspect: 96504,
    electricTerminalLugInspect: 96505,
    electricVaporizerBaseMountSecure: 96506,
    zimmerInletValveActuator: 96530,
    zimmerElectricalWiringInspect: 96531,
    zimmerDripLegHeavyEndsBuildup: 96532,
    zimmerVaporizerBaseMountSecure: 96533,
    waterBathAirFlowSwitch: 96510,
    waterBathBlowerWheel: 96511,
    waterBathBurnerFuelLines: 96512,
    waterBathBurnerFlameVisual: 96513,
    waterBathBurnerGasValveLeakTest: 96514,
    waterBathBurnerRegulators: 96515,
    waterBathElectricalControlBox: 96516,
    waterBathIgnitionCableFlameFailure: 96517,
    waterBathFloatChamberDrain: 96518,
    waterBathFluidPhLevel: 96519,
    waterBathHiLoGasPressureInterlock: 96520,
    waterBathPurgeInletOutletPiping: 96521,
    waterBathLiquidInletOperation: 96522,
    waterBathLowWaterCutOff: 96528,
    waterBathOperationControlsSafety: 96523,
    waterBathPumpsMotorsOil: 96524,
    waterBathBlowDownStrainer: 96525,
    waterBathFlueBlockage: 96526,
    waterBathWiringInspect: 96527,
    evaluationInspector: 9570,
    inspectorCertificateNumber: 9571,
    installationAcceptable: 9572,
    evaluationFollowUpNeeded: 9573,
    deficiency: 9580,
    followupInspectionDate: 9581,
    complianceTimeframe: 9582,
    makingCorrections: 9583,
    followupCorrectiveAction: 9584,
    deficiencyCorrectedBy: 9585,
    deficiencyCorrectedDate: 9586,
    pictureOfRedTag: 9587,
    correctionPhoto: 9588,
    correctionComments: 9589,
    followupTechnicianCertificateNumber: 9590,
    signOffComments: 9591,
    actionTaken: 9592,
    technicianComments: 9593,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  PP08: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    inspectionNo: 9610,
    inspectionType: 9611,
    inspectionDate: 9612,
    inspectionOutcome: 9613,
    outcomeRemarks: 9614,
    equipmentType: 9620,
    equipmentInspectionOutcome: 9621,
    fsdLabelNumber: 9622,
    tssaLicenseImage: 9623,
    dangerLabelsAffixed: 9630,
    tssaFsdLabelInPlace: 9631,
    lockableWheels: 9632,
    gasComponentsApproved: 9633,
    gasLinesGoodCondition: 9634,
    cylinderSupportedSecured: 9635,
    cabinetWellVentilated: 9636,
    clearancesMaintained: 9637,
    appliancesGoodCondition: 9638,
    equipmentLeakTight: 9639,
    supplyPressuresSetProperly: 9640,
    appliancesIgniteProperly: 9641,
    ownerUnderstandsDangerLabelling: 9642,
    evaluationInspector: 9650,
    inspectorCertificateNumber: 9651,
    installationAcceptable: 9652,
    evaluationFollowUpNeeded: 9653,
    deficiency: 9660,
    followupInspectionDate: 9661,
    complianceTimeframe: 9662,
    makingCorrections: 9663,
    followupCorrectiveAction: 9664,
    deficiencyCorrectedBy: 9665,
    deficiencyCorrectedDate: 9666,
    pictureOfRedTag: 9667,
    correctionPhoto: 9668,
    correctionComments: 9669,
    followupTechnicianCertificateNumber: 9670,
    signOffComments: 9671,
    actionTaken: 9672,
    technicianComments: 9673,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  'PP-API': {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    blowDownStrainer: 9320,
    removeStrainerBasket: 9321,
    cathodicProtection: 9322,
    undergroundPipingPhotos: 9323,
    verifyWeepHoleDeflectors: 9330,
    completePrvCycle: 9331,
    lastPrvInspectionDate: 9332,
    cycleLubricateHandWheelGears: 9340,
    verifyBleederValveOperation: 9341,
    inspectEntireManifoldLeaks: 9342,
    inspectMultiPortCorrosion: 9343,
    checkBreatherVentFilter: 9350,
    iscPhoto1: 9351,
    iscPhoto2: 9352,
    pressureTestHoses: 9360,
    fireExtinguishersRecertified: 9370,
    fireExtinguisherPhoto1: 9371,
    fireExtinguisherPhoto2: 9372,
    employeeEmergencyTraining: 9380,
    siteSpecificEmergencyTraining: 9381,
    emergencyEvacuationExercise: 9382,
    mockEmergencyExercise: 9383,
    signOffComments: 9390,
    actionTaken: 9391,
    inspectionNo: 9400,
    inspectionType: 9401,
    inspectionDate: 9402,
    inspectionOutcome: 9403,
    outcomeRemarks: 9404,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  PP09: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    checkGuards: 9700,
    checkPumpMotorCoupling: 9701,
    checkBeltTensionApprox1InchDeflection: 9702,
    checkForLeaksAroundSealsFlangeConnectors: 9703,
    greaseLubricationFittingsAsRequired: 9704,
    checkRemoteReleaseLeverLatch: 9705,
    checkPackingJointsForLeakage: 9706,
    checkThatCylindersOpenCloseFully: 9707,
    lubricateOperatingLeverClevisPivotAsRequired: 9708,
    checkBreatherVentFilterOnCylinder: 9709,
    visualInspectionOfAirNitrogenLines: 9710,
    checkRemoteReleaseLeverLatchFusibleLink: 9711,
    checkThatCylindersOpenAndCloseFully: 9712,
    inspectCleanLubricateOperatingControlsAsRequired: 9713,
    iscCheckBreatherVentFilterOnCylinder: 9714,
    testMinimumTwoStationsMonthRotationalBasis: 9715,
    listStationsTested: 97150,
    checkPaintTouchUpScratchesScheduleRepainting: 9716,
    checkTankGroundCables: 9717,
    checkRotoGaugeFixedLevelGaugeOperationLubricateAsRequired: 9718,
    checkForLeaksMakeRepairs: 9719,
    checkPaintTouchUpScratchesScheduleRepaintingPiping: 9720,
    liquidVapourPipingIdentified: 9721,
    checkForSmoothOperationLubricateAsRequired: 9722,
    checkForLeaksAroundStemConnectors: 9723,
    checkForDebrisLeaksAroundSeatWithMirror: 9724,
    checkThatCapsCoversInPlaceWeatherproof: 9725,
    visualInspectionAbrasionLeaksExcessiveWear: 9726,
    checkPullAwayFittingsCablesConnectorsFreeOfDamage: 9727,
    checkHoseEndCouplings: 9728,
    checkThreadsGasketsExcessiveWear: 9729,
    checkCouplingExteriorDamageEnsureDustCapsInPlace: 9730,
    checkConditionOfBondingCables: 9731,
    checkContinuityClampOnFittingToPlantOhms: 9732,
    checkAirDryerFilterReplaceAsRequired: 9733,
    checkOperationRegulatorPressureSwitches: 9734,
    drainMoistureFromAirCompressor: 9735,
    inspectElectricalComponentsWiringSupportsKnockoutsSecure: 9736,
    pestControlInPlaceElectricalSheds: 9737,
    allYardLightingOperational: 9738,
    visualInspectionHolesGapsSagsDamage: 9739,
    checkOperationGatesLatchesLocks: 9740,
    sprayVegetationRemovalAsRequired: 9741,
    inspectPotholesRutsDamagedAreas: 9742,
    signagePostedAtEntrancesExits: 9743,
    signagePostedAtDispenser: 9744,
    emergencyShutOffsPosted: 9745,
    emergencyShutoffsPosted: 9746,
    yatdClearOfDebrisAndGarbage: 9747,
    accessToAllEmergencyExitsClear: 9748,
    fireExtinguishersChargedTagged: 9749,
    emergencyPhoneNumbersPosted: 9750,
    emergencyLightingTested: 9751,
    evacuationMeetingLocationMusterPointPosted: 9752,
    audibleVisualAlarmsOperational: 9753,
    calibrateBranchPortable4GasDetectionMonitors: 9754,
    spillKitAccessibleAndStocked: 9755,
    evaluationInspector: 9756,
    inspectorCertificateNumber: 9757,
    installationAcceptable: 9758,
    evaluationFollowUpNeeded: 9759,
    deficiency: 9760,
    followupInspectionDate: 9761,
    complianceTimeframe: 9762,
    makingCorrections: 9763,
    followupCorrectiveAction: 9764,
    deficiencyCorrectedBy: 9765,
    deficiencyCorrectedDate: 9766,
    pictureOfRedTag: 9767,
    correctionPhoto: 9768,
    correctionComments: 9769,
    followupTechnicianCertificateNumber: 9770,
    signOffComments: 9771,
    actionTaken: 9772,
    inspectionNo: 9773,
    inspectionType: 9774,
    inspectionDate: 9775,
    inspectionOutcome: 9776,
    outcomeRemarks: 9777,
    technicianComments: 9778,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  PP24: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    equipment: 98400,
    equipmentMake: 98401,
    equipmentModel: 98402,
    tuneUpBeforePhoto: 98403,
    tuneUpAfterPhoto: 98404,
    tuneUpRatingsPlate: 98405,
    tuneUpEquipmentComments: 98406,
    testSafetyControls: 98410,
    cleanIgnitionPilotAssembly: 98411,
    examineHeatExchanger: 98412,
    monitorFlueDraft: 98413,
    cleanBurnerAssembly: 98414,
    cleanOrReplaceStandardAirFilters: 98415,
    cleanBlowerComponents: 98416,
    measureTemperatureRise: 98417,
    tightenElectricalConnection: 98418,
    lubricateAllMovingParts: 98419,
    checkThermostatCalibrations: 98420,
    cleanCondensateDrains: 98421,
    checkClearanceToCombustibles: 98422,
    testIgnitionCycle: 98423,
    monitorHealingCycle: 98424,
    measureIgnitorResistance: 98425,
    vacuumAndExamineInnerCabinets: 98426,
    checkVentingComponents: 98427,
    checkGasConnections: 98428,
    applyMaintenanceDecalTag: 98429,
    after8Notes: 98430,
    after9Notes: 98431,
    after11Notes: 98432,
    after13Notes: 98433,
    after16SummaryNotes: 98434,
    tuneUpMidNotes: 98435,
    tuneUpEndNotes: 98436,
    tuneUpSectionPhoto: 98437,
    evaluationInspector: 98450,
    inspectorCertificateNumber: 98451,
    installationAcceptable: 98452,
    evaluationFollowUpNeeded: 98453,
    deficiency: 98460,
    followupInspectionDate: 98461,
    complianceTimeframe: 98462,
    makingCorrections: 98463,
    followupCorrectiveAction: 98464,
    deficiencyCorrectedBy: 98465,
    deficiencyCorrectedDate: 98466,
    pictureOfRedTag: 98467,
    correctionPhoto: 98468,
    correctionComments: 98469,
    followupTechnicianCertificateNumber: 98470,
    signOffComments: 98471,
    actionTaken: 98472,
    inspectionNo: 98473,
    inspectionType: 98474,
    inspectionDate: 98475,
    inspectionOutcome: 98476,
    outcomeRemarks: 98477,
    technicianComments: 98478,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  CI: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    ...CI_STATIC_FIELD_MAPPINGS,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  HI: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    ...HI_STATIC_FIELD_MAPPINGS,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  VENTI: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    ...VENTI_STATIC_FIELD_MAPPINGS,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
  SE06: {
    ...SHARED_GENERAL_INFO_MAPPINGS,
    inspectionNo: 9710,
    inspectionType: 9711,
    inspectionDate: 9712,
    inspectionOutcome: 9713,
    outcomeRemarks: 9714,
    nearestBuildingDistanceCompliance: 9720,
    adjoiningPropertyDistanceCompliance: 9721,
    publicThoroughfareDistanceCompliance: 9722,
    schoolsChurchesDistanceCompliance: 9723,
    slipAndFall: 9730,
    inTheLineOfFire: 9731,
    movingObjectsOrEquipments: 9732,
    limitedEgress: 9733,
    potentiallyHazardousAtmosphere: 9734,
    highVehicleTrafficArea: 9735,
    overheadWires: 9736,
    groundDisturbance: 9737,
    overheadCraneBoom: 9738,
    unstableRoadway: 9739,
    riskRatingRot: 9740,
    riskRatingPhotos: 9742,
    listAllControlsNecessary: 9741,
    evaluationInspector: 9790,
    inspectorCertificateNumber: 9791,
    installationAcceptable: 9792,
    installationPhotos: 9793,
    tankRatingPlate: 9794,
    evaluationFollowUpNeeded: 9795,
    deficiency: 9810,
    followupInspectionDate: 9811,
    complianceTimeframe: 9812,
    makingCorrections: 9813,
    followupCorrectiveAction: 9814,
    deficiencyCorrectedBy: 9815,
    deficiencyCorrectedDate: 9816,
    pictureOfRedTag: 9817,
    correctionPhoto: 9818,
    correctionComments: 9819,
    followupTechnicianCertificateNumber: 9822,
    signOffComments: 9820,
    actionTaken: 9821,
    technicianComments: 9823,
    ...SHARED_TECH_SIGNATURE_MAPPINGS,
  },
};

export function getStaticFormFieldMappings(formCode: string): StaticFormFieldMappings | undefined {
  return STATIC_FORM_FIELD_MAPPINGS[formCode];
}

export function getStaticFormFieldMappingsById(formId: number): StaticFormFieldMappings | undefined {
  const formCodeById: Record<number, string> = {
    1: 'SE01',
    2: 'SE02',
    3: 'PP01',
    4: 'PP06',
    5: 'PP07',
    6: 'PP08',
    7: 'SA01',
    8: 'DE02',
    2107: 'PP07',
    2101: 'PP01',
    2103: 'PP03',
    2106: 'PP06',
    2108: 'PP08',
    2109: 'PP09',
    2124: 'PP24',
    2112: 'PP-DISP',
    2113: 'PP-API',
    2306: 'SE06',
    2310: 'CI',
    2311: 'HI',
    19: 'VENTI',
  };
  const formCode = formCodeById[formId];
  return formCode ? getStaticFormFieldMappings(formCode) : undefined;
}
